module.exports = {
	"id": "VC",
	"name": "Saint Vincent and the Grenadines",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.047523,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.006789,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.027156,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.006789,
			"30": null,
			"31": 0.033945,
			"32": 0.027156,
			"33": 0.020367,
			"34": 0.006789,
			"35": 0.006789,
			"36": 0.013578,
			"37": null,
			"38": 0.020367,
			"39": 0.047523,
			"40": 0.054312,
			"41": 0.013578,
			"42": 0.020367,
			"43": 0.237615,
			"44": 0.040734,
			"45": 0.027156,
			"46": 0.033945,
			"47": 0.054312,
			"48": 0.033945,
			"49": 1.28991,
			"50": 0.468441,
			"51": 1.330644,
			"52": 0.835047,
			"53": 27.658386,
			"54": 6.558174,
			"55": 0.230826,
			"56": 0.040734,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.013578,
			"12": null,
			"13": null,
			"14": 0.013578,
			"15": null,
			"16": 0.27156,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.013578,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.027156,
			"39": 0.013578,
			"40": null,
			"41": null,
			"42": 0.013578,
			"43": 0.122202,
			"44": null,
			"45": 0.033945,
			"46": 0.183303,
			"47": 0.536331,
			"48": 0.461652,
			"49": 5.63487,
			"50": 0.386973,
			"51": 0.020367,
			"52": null,
			"3.5": null,
			"3.6": 0.033945
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.054312,
			"30": 0.033945,
			"31": null,
			"32": null,
			"33": 0.013578,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.264771,
			"38": 0.210459,
			"39": 0.074679,
			"40": 0.556698,
			"41": 0.101835,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.020367
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.033945,
			"6": null,
			"7": null,
			"8": 0.06789,
			"9": 3.73395,
			"10": 1.113396,
			"3.1": null,
			"3.2": null,
			"5.1": 0.386973,
			"6.1": 0.420918,
			"7.1": null,
			"9.1": 0.488808
		},
		"ios_saf": {
			"8": 0,
			"10": 2.11600889592,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0570239912573,
			"8.1-8.4": 0.105349407577,
			"9.0-9.2": 0.0502584329725,
			"9.3": 0.766763272273
		},
		"android": {
			"3": 0,
			"4": 0.0822995064599,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0102874383075,
			"4.1": 0.296866076873,
			"4.2-4.3": 0.742165192183,
			"4.4": 1.70183622287,
			"4.4.3-4.4.4": 1.71653256331
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.190092,
			"9": 0.142569,
			"10": 0.353028,
			"11": 3.136518,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0409662249615,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00113795069337
		},
		"edge": {
			"12": 0.162936,
			"13": 1.031928,
			"14": 1.724406
		},
		"ie_mob": {
			"10": 0.147525098592,
			"11": 0.600637901408
		},
		"bb": {
			"7": 0.1717885,
			"10": null
		},
		"samsung": {
			"0": 2.47247
		},
		"and_uc": {
			"0": 1.416051
		},
		"op_mini": {
			"0": 0.551930824345
		},
		"and_chr": {
			"0": 23.89858
		},
		"and_ff": {
			"0": 0.006422
		}
	},
	"total": 98.2439925
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/VC.json
 ** module id = 676
 ** module chunks = 0
 **/